import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchProviderCertificationDetails = createAsyncThunk(
  "fetchProviderCertificationDetails",
  async (providerId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/general-certifications`
    );
    return response.data;
  }
);

export const fetchProviderCertificationSuggesion = createAsyncThunk(
  "fetchProviderCertificationSuggesion",
  async (query = "") => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/certifications?query=${query}&view=search`
    );
    return response;
  }
);

export const deleteProviderGeneralCert = createAsyncThunk(
  "deleteProviderGeneralCert",
  async ({ providerId, certificationDisplayId }) => {
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/general-certifications/${certificationDisplayId}`,[]
    );
    return response.data;
  }
);

export const saveProviderCertifications = createAsyncThunk(
  "saveProviderCertifications",
  async ({ providerId, certifications }) => {
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/general-certifications`,
      { certifications }
    );
    return response.data;
  }
);